import React from "react"
import classNames from "classnames"
import moment from "moment"
import ActionRowItem from "./ActionRowItem"
import styles from "../OnDemandTable.module.css"

export default function TableRowItem(props) {
    const {data, onClickShowDetail, onClickRowItem, model} = props
    const {dateFormat} = model

    return (
        <tr key={data.id} className={styles.tableRow}>
            <td className={classNames(styles.tableCell, styles.cursor)} onClick={() => onClickRowItem(data)}>
                {data.title}
            </td>
            <td className={styles.tableCell}>{data.role}</td>
            <td className={styles.tableCell}>{data.department}</td>
            <td className={styles.tableCell}>{data.usersAssigned}</td>
            <td className={styles.tableCell}>{data.createdAt ? moment(data.createdAt).format(dateFormat) : ""}</td>
            <td className={styles.tableCell}>
                <ActionRowItem data={data} onClickShowDetail={onClickShowDetail} />
            </td>
        </tr>
    )
}
